import React from "react";

/**
 * ToyCycleHub colorful brutalist logo.
 * - Yellow rounded square background (border-2 border-gray-900, brutalist shadow)
 * - Pink "T" + Blue "C" + Green "H" stacked block letters spelling "TCH"
 * - Tiny recycle arrow underneath in red
 *
 * Use `<ToyCycleLogo size={48} />` for icon-only, or pair with the text wordmark
 * via `<ToyCycleWordmark />`.
 */
export const ToyCycleLogo = ({ size = 40, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    role="img"
    aria-label="ToyCycleHub"
    data-testid="toycycle-logo"
  >
    {/* Brutalist drop shadow */}
    <rect x="4" y="6" width="40" height="40" rx="9" fill="#111827" />
    {/* Yellow background tile */}
    <rect x="2" y="3" width="40" height="40" rx="9" fill="#FFD93D" stroke="#111827" strokeWidth="2.5" />

    {/* Three stacked block letters T-C-H using overlapping color shapes */}
    {/* Pink T */}
    <g transform="translate(7,7)">
      <rect x="0" y="0" width="14" height="4" fill="#FF6B6B" stroke="#111827" strokeWidth="1.5" rx="1" />
      <rect x="5" y="2" width="4" height="11" fill="#FF6B6B" stroke="#111827" strokeWidth="1.5" rx="1" />
    </g>
    {/* Blue C (open ring) */}
    <g transform="translate(24,7)">
      <path
        d="M12,2 A6,6 0 1,0 12,11 L12,8 A3,3 0 1,1 12,5 Z"
        fill="#4A90E2"
        stroke="#111827"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </g>
    {/* Green H */}
    <g transform="translate(7,23)">
      <rect x="0" y="0" width="3.5" height="14" fill="#10B981" stroke="#111827" strokeWidth="1.5" rx="1" />
      <rect x="10.5" y="0" width="3.5" height="14" fill="#10B981" stroke="#111827" strokeWidth="1.5" rx="1" />
      <rect x="0" y="5.5" width="14" height="3" fill="#10B981" stroke="#111827" strokeWidth="1.5" rx="0.5" />
    </g>
    {/* Recycle arrow loop in purple bottom-right */}
    <g
      className="toycycle-recycle"
      transform="translate(26,28)"
      stroke="#111827"
      strokeWidth="1.4"
      fill="#9B59B6"
      strokeLinejoin="round"
      style={{ transformOrigin: "30px 36px" }}
    >
      <path d="M2,5 A5,5 0 1,1 7,10 L9,12 L4,12 L4,8 L6,9 A3,3 0 1,0 4,5 Z" />
    </g>
  </svg>
);

/** Compact wordmark with logo + brand text. */
export const ToyCycleWordmark = ({ size = 36 }) => (
  <span className="inline-flex items-center gap-2" data-testid="toycycle-wordmark">
    <ToyCycleLogo size={size} />
    <span
      className="font-black tracking-tight text-lg sm:text-xl"
      style={{ fontFamily: "Outfit, sans-serif" }}
    >
      Toy<span className="text-[#FF6B6B]">Cycle</span>
      <span className="text-[#4A90E2]">Hub</span>
    </span>
  </span>
);
